module.exports = __webpack_public_path__ + "static/img/50.026f3f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/50.png
// module id = wPc7
// module chunks = 0